import { render, staticRenderFns } from "./university.vue?vue&type=template&id=60635ab4&scoped=true&"
import script from "./university.vue?vue&type=script&lang=js&"
export * from "./university.vue?vue&type=script&lang=js&"
import style0 from "./university.vue?vue&type=style&index=0&id=60635ab4&lang=scss&scoped=true&"
import style1 from "./university.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60635ab4",
  null
  
)

export default component.exports